import $ from "jquery";
import "slick-carousel";

console.log('faqs-slider.js');

$(".js-faqs-slider").each(function () {
  const $block = $(this);

  const $track = $block.find(".js-faqs-slider__track");
//   const $prev = $block.find(".js-slider-arrow-prev");
//   const $next = $block.find(".js-slider-arrow-next");
  const $dots = $block.find(".js-faqs-slider__dots");

  $track.slick({
    infinite: true,
    centerMode: true,
    autoplay: false,
    // slidesToShow: 3,
    // slidesToScroll: 1,
    variableWidth: true,
    dots: true,
    dotsClass: "",
    appendDots: $dots,
    draggable: true,
    adaptiveHeight: false,
	arrows: false,
    // nextArrow: $next,
    // prevArrow: $prev,
    fade: false,
    responsive: [
      {
        breakpoint: 576,
        settings: {
          centerMode: false,
          variableWidth: false,
          slidesToShow: 1,
          slidesToScroll: 1,
          fade: true,
        },
      },
    ],
  });
});
